define(['app', 'jquery', './base'], function (app, $, Helper) {
  return Helper.extend({
    ui: {
      link: '.js-mark-answer'
    },

    events: {
      'click @ui.link': 'markAnswer'
    },

    markAnswer: function (e) {
      e.preventDefault()

      $.ajax(this.ui.link.attr('href'), {
        type: 'POST',
        success: function () {
          window.location.reload(true)
        },
        error: function () {
          window.location.reload(true)
        }
      })
    }
  })
})
